export { TemplateModalButton as default } from "./template-modal-button.tsx";
export * from "./template-modal-button.tsx";
